import { render } from "./ShopRanking.vue?vue&type=template&id=b35b974c&scoped=true"
import script from "./ShopRanking.vue?vue&type=script&lang=js"
export * from "./ShopRanking.vue?vue&type=script&lang=js"

import "./ShopRanking.vue?vue&type=style&index=0&id=b35b974c&lang=scss&scoped=true"

import exportComponent from "D:\\CTL-Project\\ChatBotSHLX\\web-ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b35b974c"]])

export default __exports__